var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.11111C0 1.55121 0.210714 1.01424 0.585786 0.61833C0.960859 0.22242 1.46957 0 2 0H13.586C14.1164 0.000119568 14.625 0.222618 15 0.618556L17.707 3.47594C17.8946 3.67385 17.9999 3.94229 18 4.22222V16.8889C18 17.4488 17.7893 17.9858 17.4142 18.3817C17.0391 18.7776 16.5304 19 16 19H2C1.46957 19 0.960859 18.7776 0.585786 18.3817C0.210714 17.9858 0 17.4488 0 16.8889V2.11111ZM6 16.8889H12V10.5556H6V16.8889ZM14 16.8889H16V4.65922L14 2.54811V4.22222C14 4.78212 13.7893 5.31909 13.4142 5.715C13.0391 6.11091 12.5304 6.33333 12 6.33333H6C5.46957 6.33333 4.96086 6.11091 4.58579 5.715C4.21071 5.31909 4 4.78212 4 4.22222V2.11111H2V16.8889H4V10.5556C4 9.99565 4.21071 9.45868 4.58579 9.06278C4.96086 8.66687 5.46957 8.44444 6 8.44444H12C12.5304 8.44444 13.0391 8.66687 13.4142 9.06278C13.7893 9.45868 14 9.99565 14 10.5556V16.8889ZM6 2.11111V4.22222H12V2.11111H6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.d31f75c457c30e727672b330160be408.svg";
export { ForwardRef as ReactComponent };